import ReactTooltip from "react-tooltip";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

interface ThreeSixtyRerunIconProps {
  tooltipId: string;
}

interface ThreeSixtyRerunRow {
  rerun_from_parent_uuid?: string | null;
}

export function isRerunRow(row: ThreeSixtyRerunRow): boolean {
  return Boolean(row.rerun_from_parent_uuid);
}

export function getRerunTooltipId(requestUuid: string): string {
  return `three-sixty-rerun-${requestUuid}`;
}

export function ThreeSixtyRerunIcon({ tooltipId }: ThreeSixtyRerunIconProps) {
  return (
    <span
      aria-label="Rerun"
      className="inline-flex cursor-pointer"
      data-for={tooltipId}
      data-tip="Rerun"
      role="img"
    >
      <ArrowPathIcon
        className="w-5 ml-2 text-blue-600"
        data-testid="three-sixty-rerun-icon-svg"
      />
    </span>
  );
}

export function ThreeSixtyRerunTooltip({
  tooltipId,
}: ThreeSixtyRerunIconProps) {
  return (
    <ReactTooltip
      className="hover:visible:opacity-1 px-3 py-2 leading-normal"
      effect="solid"
      id={tooltipId}
    />
  );
}
